// Primitivos transversais para operações assíncronas canceláveis.
// Usado por: retry.js, useYouTubeMeta, useMediaUpload, uploadPostMedia.

export const makeAbortError = () => {
    const err = new Error('Aborted');
    err.name = 'AbortError';
    return err;
};

// Sleep cancelável: integra com AbortController para latência de cancelamento O(0).
export const abortableSleep = (ms, signal) =>
    new Promise((resolve, reject) => {
        if (signal?.aborted) return reject(makeAbortError());
        const t = setTimeout(resolve, ms);
        const onAbort = () => {
            clearTimeout(t);
            reject(makeAbortError());
        };
        signal?.addEventListener('abort', onAbort, { once: true });
    });

// Rede de segurança contra promise que nunca resolve (ex.: requisição Supabase
// que estola sem resposta — o fetch do RN não tem timeout nativo). Rejeita com
// um TimeoutError após `ms`; repassa resolve/reject originais se chegarem antes.
export const withTimeout = (promise, ms, message = 'Tempo esgotado') =>
    new Promise((resolve, reject) => {
        const t = setTimeout(() => {
            const err = new Error(message);
            err.name = 'TimeoutError';
            reject(err);
        }, ms);
        promise.then(
            (v) => { clearTimeout(t); resolve(v); },
            (e) => { clearTimeout(t); reject(e); },
        );
    });

// Predicate: HTTP status indica erro transiente (retryable)?
// Para erros sem status (rede), retorna true — assume falha transitória.
export const isTransientError = (e) => {
    if (e?.name === 'AbortError') return false;
    const match = /HTTP (\d+)/.exec(e?.message || '');
    if (!match) return true;
    const code = +match[1];
    return code >= 500 || code === 408 || code === 429;
};
